import "./mobileTutorialComponent.scss";
import {useLangContext} from 'shared/features/Language';
import {CustomButton} from "../../../../shared/components/Buttons/CustomButton";
import arrowHead from "../../../../shared/assets/icons/arrow-head.svg";

interface IProps {
  step: number;
  onClick: () => void;
  top: number;
  bottom: number;
}

export const MobileTutorialComponent = ({onClick, step, top, bottom}: IProps) => {
  const {textData} = useLangContext();
  return (
    <div className={`assembly-mobile-tutorial step-${step}`}>
      <div className="step-2-visible">
        <div className="cap cap-1"></div>
        <div className="bg-1" style={{top: `${top}px`}}>
          <div className="block block1">
            <div className="arrow arrow-up">
              <img src={arrowHead} alt=""/>
            </div>
            <div className="text">{textData.mobileTutorialBlock1}</div>
          </div>
          <div className="block block2">
            <div className="arrow arrow-up">
              <img src={arrowHead} alt=""/>
            </div>
            <div className="text">{textData.mobileTutorialBlock2}</div>
          </div>
          <div className="btn-wrapper">
            <CustomButton
              onClick={onClick}
              width="150px"
            >{textData.buttonCaptionNext}</CustomButton>
          </div>
        </div>
      </div>
      <div className="step-1-visible">
        <div className="bg-2">
          <div className="block block3" style={{marginTop: `calc(${top}px + 10vw)`}}>
            <div className="filter"></div>
            <div className="arrow arrow-up">
              <img src={arrowHead} alt=""/>
            </div>
            <div className="text">{textData.mobileTutorialBlock3}</div>
          </div>
          <div className="btn-wrapper">
            <CustomButton
              onClick={onClick}
              width="150px"
            >{textData.buttonCaptionNext}</CustomButton>
          </div>
        </div>
      </div>
      <div className="step-0-visible">
        <div className="bg-3" style={{height: `calc(${bottom}px + 0px)`}}>
          <div className="btn-wrapper">
            <CustomButton
              onClick={onClick}
              width="150px"
            >{textData.buttonCaptionItsClear}</CustomButton>
          </div>
          <div className="block block4">
            <div className="text">{textData.mobileTutorialBlock4}</div>
            <div className="arrow arrow-down">
              <img src={arrowHead} alt=""/>
            </div>
          </div>
        </div>
        <div className="cap cap-2"></div>
      </div>
    </div>
  )
}
